import { Component, Input } from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';
import { IMaps } from '@core/interfaces/interface';

@Component({
  selector: 'app-google-map-launcher',
  imports: [GoogleMapsModule],
  standalone: true,
  templateUrl: './google-map-launcher.component.html',
  styleUrl: './google-map-launcher.component.scss',
})
export class GoogleMapLauncherComponent {
  @Input() public width: string = '100%';
  @Input() public height: string = '100%';
  @Input() public zoom: number = 10;
  @Input() public position: IMaps = { lat: 50.450001, lng: 30.523333 };
}
